<template>
  <div class="nft-sort-filter-comp">
    <div class="filter-button" @click="openSheet">
      <img src="@/assets/images/icons/sort.svg">
    </div>
    <bottom-slide-sheet
        v-model:visible="isOpen"
        title="listFilter.title"
    >
      <template #content>
        <div class="filter-area">
          <div class="filter-group mb-16">
            <div class="group-name">{{ $t('listFilter.sort') }}</div>
            <div>

            </div>
            <div
                v-for="(filter, index) in sortOption"
                :key="index"
                class="filter-item"
                @click="selectSort(filter.value)"
            >
              {{ $t(filter.label) }}
              <img
                  v-show="selected.sort === filter.value"
                  src="@/assets/images/icons/check.svg"
              >
            </div>
          </div>
          <div class="filter-group mb-24" v-if="viewMode === 'nft'">
            <div class="group-name">{{ $t('listFilter.status') }}</div>
            <div
                v-for="(filter, index) in statusOption"
                :key="index"
                class="filter-item"
                @click="selectStatus(filter.value)"
            >
              {{ $t(filter.label) }}
              <img
                  v-show="selected.status === filter.value"
                  src="@/assets/images/icons/check.svg"
              >
            </div>
          </div>
          <div class="button-row">
            <MvButton
                text="common.apply"
                type="rec-primary"
                @click="applyFilter"
            />
          </div>
        </div>
      </template>
    </bottom-slide-sheet>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import BottomSlideSheet from '@/components/common/modal/BottomSlideSheet.vue';
import {useModal} from '@/script/common/modalScript';
import MvButton from '@/components/common/button/MvButton.vue';
import {useHomeListConfig, useHomeListModeConfig, useHomeListSortConfig, useNftFilter} from '@/script/homeScript';
import {NftSortFilter} from '@/models/types';

export default defineComponent({
  name: 'NftSortFilterComp',
  components: {
    MvButton,
    BottomSlideSheet
  },
  setup() {
    const {
      toggleModal,
      isOpen,
    } = useModal()

    const {
      listMode,
      isActive,
      changeMode,
    } = useHomeListModeConfig()

    const {
      nftSort,
      changeSort,
    } = useHomeListSortConfig()

    const {
      viewMode,
    } = useHomeListConfig()

    const initConfig = () => {
      selected.sort = nftSort.value
      selected.status = isActive.value
    }

    const openSheet = () => {
      initConfig()
      toggleModal(true)
    }

    const {
      sortOption,
      statusOption,
      selected,
    } = useNftFilter()

    const selectSort = (value: NftSortFilter) => {
      selected.sort = value
    }

    const selectStatus = (value: boolean) => {
      selected.status = value
    }

    const applyFilter = () => {
      if (selected.sort !== nftSort.value) {
        changeSort(selected.sort)
      }
      if (selected.status !== isActive.value) {
        changeMode(selected.status)
      }
      toggleModal(false)
    }

    return {
      toggleModal,
      isOpen,
      sortOption,
      statusOption,
      selected,
      selectSort,
      selectStatus,
      openSheet,
      applyFilter,
      viewMode,
    }
  }
})
</script>
